module.exports = {
  common: {
    message: 'Data Retrieval Failed',
    toast: 'Please Complete Information'
  },
  vantText: {
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  MealNum: {
    title: "Restaurant Name",
    lang: "Choose Language",
    chooseLang: 'Please Choose Language',
    mealNum: "Number of Persons",
    seat: 'Submit',
    text: 'Enter total number of people dining'
  },
  ShopInfo: {
    title: "Restaurant Info",
    name: "Name",
    address: "Address",
    phone: "Phone Number",
    time: "Open Hours",
    intro: "Introduction",
  },
  OrderDetail: {
    uploadVoucher: "Upload Voucher",
    accountInformation: "Account Information",
    title: "Order Detail",
    success: 'Ordered',
    pay: 'Paid',
    unpaid: 'Unpaid',
    totalNum: 'Total Number of People',
    status0: "Preparing",
    status1: "making", //制作中
    status2: "Prepared",
    status3: "Served",
    status4: "Delivered",
    status5: "Dish Rejected",
    time: 'Order Time',
    orderNum: 'Order Number',
    back: 'Back',
    confirm: 'Confirm',
    voucherTip: "Please upload the voucher picture",
    message: 'Data Error',
    containerOrder: 'Continue Order',
    goPay: 'Pay',
    loading: 'loading...',
    cashPay: 'Please check out at the counter',
    subtitle: "Submit Order",
    needPay: "Amount receivable",
    pricePay: "Amount",
    toPay: "To be paid",
    ticket: "Order #",
    ticketTip: 'Please screenshot this page.  Show Order # when at store. Thank you. ',
    addressMoney: 'Regional additional amount',
    continue: "Order More",
    submit: "Submit",
    view: 'Check Order',
    checkOrder: 'Order Details',
    orderStatus: 'Order Status',
    order0: 'payment successful',
    order1: 'Payment failed',
    order2: 'Payment cancellation',
    returnOrder: 'Return order',
    newOrder: 'Re-order',
    againOrder: 'Another order',
    noPayOrder: 'The order has timed out without payment, please place another order.',
    plsPay: 'Please confirm that payment has been made.',
    prompt: 'Please check out at the counter',
    CounterTitle: 'success',
  },
  Dishes: {
    title: 'Please select',
    orderDetail: 'Order Detail',
    name: 'Menu',
    nonefood: 'No Product',
    cart: 'Order Cart',
    order: 'Place Order',
    package: "Combo Meal",
    del: 'Delete',
    isDel: 'Order Quantity Is 1. Do You Want To Remove From Order Cart?',
    addfood: 'Add Product',
    none: 'nothing',
    continueOrder: 'Continue order'
  },
  PackageDetail: {
    title: "Details",
    chooseSpecs: 'Options',
    note: 'Flavor',
    remark: 'Remark',
    inputRemark: "Input Remark",
    certain: 'Confirm',
    addToCart: 'Add To Cart',
  },
  Home: {
    shopName: 'Restaurant Name:',
    address: 'Restaurant Address：',
    intro: "Introduction",
    phone: "Telephone:",
    startTime: "Open Hours:",
    endTime: "Closing Hours:",
    bookBtn: 'make an appointment',
    takeawayBtn: 'Order',
    menuBtn: 'Menu',
    pickup: 'Pack',
    packNumber: 'Pack Number',
    p: 'Fastpoint Ordering System',
    more: 'Click To Know More',
  },
  InputInfo: {
    paymentVoucher: 'Payment Voucher',
    title: "Booking",
    name: 'Name',
    inputName: 'Input Name',
    phone: 'Phone Number',
    inputPhone: "Enter Phone Number",
    maelNum: 'NOs of persons',
    inputMealNum: "Please Enter Number of Persons",
    gender: "Gender",
    woman: 'Female',
    man: 'Male',
    bookdate: "Booking Date",
    bookMealTime: "Booking Time",
    submit: 'Submit',
    address: 'Receiving address',
    inputAddress: 'Please enter the shipping address',
    comment: 'Note',
    deliveryTime: "Delivery Time",
    deliveryDate: "Delivery Date",
    PickUpDate: "Pick-Up Date",
    PickUpTime: "Pick-Up Time",
    inputComment: 'Please enter Note',
    inputDeliveryTime: "Please enter Delivery Time",
    inputDeliveryDate: "Please enter Delivery Date",
    inputPickUpTime: "Please enter Pick-Up Time",
    inputPickUpDate: "Please enter Pick-Up Date"
  },
  Result: {
    title: 'Booking Detail',
    success: 'Booking Successful',
    name: 'Name',
    phone: 'Telephone Number',
    mealTime: 'Dining Time',
    mealNum: 'Number of Persons',
    people: 'Persons'
  },
  ContactUs: {
    contact: 'Contact Salesperson',
    area: 'District',
    name: 'Name',
    phone: 'Phone Number',
    hongkong: 'Hong Kong',
    taiwan: 'Taiwan',
    zhuhai: 'Zhuhai',
    shanwei: 'Shanwei',
    shenzhen: 'Shenzhen',
    shantou: 'Shantou',
    dongguan: 'Dongguan',
    guilin: 'Guilin',
    fuzhou: 'Fuzhou',
    lin: 'Mr. Lin',
    tian: 'Mr. Tin',
    chen: 'Mr. Chen',
    chan: 'Mr. Chan',
    qiu: 'Mr. Qiu',
    liu: 'Mr. Liu',
    wang: 'Mr. Wang',
    shi: 'Mr. Shi',
    misschen: 'Miss Chen'
  },
  PlaceOrderDetail: {
    floor: 'Floor',
    tableNum: 'Table Number',
    outTime: 'Order Over Time',
    cooked: 'Completed Dishes',
    overCook: 'Dishes Served',
    pay: 'Paid',
    unpaied: 'Unpaid',
    cancel: 'Cancel',
    time: 'Order Time',
    oorderNum: 'Invoice Number',
    number: 'Seated People',
    status0: 'Preparing',
    status1: 'Cooking',
    status2: 'Cooking Completed',
    status3: 'Dishes Served',
    status4: 'Dishes Arrived',
    status5: 'Dishes Cancelled',
    payMethod: 'Payment Method',
    cash: "Cash",
    wechat: 'WeChat',
    alipay: 'AliPay',
    applePay: "Apple Pay",
    creditcard: "Credit Card",
    orther: 'Other',
    payMoney: 'Paid',
    clean: 'Cleaning',
    message: 'Table Not Paid, Not Ready For Cleaning',
    print: 'Print',
    orderDetail: 'Order Detail',
    orderList: 'Order List',

    isServiceCharge: 'Whether to open the service fee',
    isDiscountFee: 'Whether to open the discount fee',
    discountCharge: 'Discount charge',

    turnTable: 'Turntable',
    isTurnTable: 'Are you sure you want to turn tables?',
    turnTableErr: 'Sorry,this seat is taken',
    confirmPay: 'Confirm Paid',
  },
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/en.js